export default __webpack_public_path__ + "static/media/character-5.acd88825.png";